class ProductAvailability extends HTMLElement {
  connectedCallback() {
    const output = this.querySelector('[data-backorder-delivery-date]');
    const businessDays = Number.parseInt(this.dataset.businessDays, 10);

    if (!output || Number.isNaN(businessDays)) return;

    const deliveryDate = this.addBusinessDays(new Date(), businessDays);
    const weekday = deliveryDate.toLocaleDateString('en-GB', { weekday: 'short' });
    const month = deliveryDate.toLocaleDateString('en-US', { month: 'short' });

    output.textContent = `${weekday}, ${deliveryDate.getDate()} ${month} ${deliveryDate.getFullYear()}`;
  }

  addBusinessDays(startDate, businessDays) {
    const result = new Date(startDate);
    result.setHours(12, 0, 0, 0);

    let remaining = businessDays;
    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();

      if (day !== 0 && day !== 6) remaining -= 1;
    }

    return result;
  }
}

if (!customElements.get('product-availability')) {
  customElements.define('product-availability', ProductAvailability);
}
